const img = require.context('.', false, /\.jpg$/);
let parseImg = [];
// console.log( "img is working" );
img.keys().forEach((key) => {
  console.log('key', key);
  parseImg.push({
    id: /\w+(.jpg|.png)/.exec(key)[0],
    text: 'image dla ' + key,
  });
});

// console.log( 'parseImg', parseImg );

export default parseImg;
